// In src/components/PrayerRequestCard.js

import React from 'react';
import { Card, CardContent, Typography, Box, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FavoriteIcon from '@mui/icons-material/Favorite'; // Using a heart for "I Prayed"

// Add currentUser prop to function signature
function PrayerRequestCard({ prayer, currentUser, userRole, onDelete, onPray }) {
  // Determine if the current user can delete this prayer
  const canDelete = currentUser.uid === prayer.authorId || userRole === 'Leadership' || userRole === 'Church Administrator';
  const creationDate = prayer.createdAt?.toDate().toLocaleDateString();

  // NEW: Check if current user has already prayed
  const hasPrayed = prayer.prayedByUids?.includes(currentUser.uid) || false;

  return (
    <Card sx={{ mb: 2, backgroundColor: prayer.isPrivate ? '#fffde7' : 'white' }}> {/* Light yellow for private prayers */}
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          {/* Prayer Text and Author Info */}
          <Box>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', mb: 2 }}>
              {prayer.text}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Submitted {prayer.isAnonymous ? 'anonymously' : `by ${prayer.authorName}`} on {creationDate}
            </Typography>
            {prayer.isPrivate && (
              <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic', display: 'block' }}>
                (Private: Visible only to you and leadership)
              </Typography>
            )}
          </Box>
          {/* Action Buttons */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ml: 2 }}>
            <Button
              variant="outlined"
              startIcon={<FavoriteIcon />}
              onClick={() => onPray(prayer.id)}
              size="small"
              disabled={hasPrayed} // <--- Disable button if user has prayed
            >
              {hasPrayed ? 'Prayed' : 'Pray'} {/* Change button text */}
            </Button>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              {prayer.prayerCount || 0} prayers
            </Typography>
            {canDelete && (
              <IconButton onClick={() => onDelete(prayer.id)} aria-label="delete" sx={{ mt: 1 }}>
                <DeleteIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default PrayerRequestCard;